// TODO: Remove from `core-js@4`
require('../modules/es.promise.all-settled.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/esnext.promise.all-settled.js
// module id = 861
// module chunks = 0